import { render, staticRenderFns } from "./marketExportRecord.vue?vue&type=template&id=a4f32444&scoped=true"
import script from "./marketExportRecord.vue?vue&type=script&lang=ts"
export * from "./marketExportRecord.vue?vue&type=script&lang=ts"
import style0 from "./marketExportRecord.vue?vue&type=style&index=0&id=a4f32444&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4f32444",
  null
  
)

export default component.exports